import * as types from '../constants/ConfigActionTypes'
import produce from 'immer'

const initialState = {
    firestore: null
};

const set = (state, key, val) => {
    state[key] = val;
    return state;
}

export default function stories (state = initialState, action) {
  switch (action.type) {
    case types.SET:
        return set(state, action.key, action.val)
    default:
      return state
  }
}
